import React from "react"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import strings from "../../localization/strings"
import { IPunchSetRecordBySupervisorDto, IPunchSetRecordDto, ERecordPageType, ERecordSearchFilter, EExceptionUITypes, EExceptionReviewDialogExceptionType } from "../../models"
import ImageLoader from "../../components/misc/ImageLoader"
import ExceptionPunchSetsTable from "./ExceptionPunchSetsTable"
import LeaveTrackingLiveView from "../leave_tracking/list_view/LeaveTrackingLiveView"
import RecordTable from "../record/RecordTable"
interface IProps {
  selectedFilterTypes: EExceptionUITypes[]
  exceptionPunchSetRecordsBySupervisorDto: IPunchSetRecordBySupervisorDto[]
  expandedRowSupervisorId: string
  handleUpdateExpandedRowSupervisorId(expandedRowSupervisorId: string): void
  onAddPunch(punchSetRecordDto: IPunchSetRecordDto): void
  onApprovePunchSet(punchSetRecordDto: IPunchSetRecordDto): void
  handleShowExceptionDailog(exceptionType: EExceptionReviewDialogExceptionType, exceptionPunchId: string): void
  reloadData(): void
}

const ExceptionPunchSetsBySupervisorTable: React.SFC<IProps> = (props: IProps) => {
  return (
    <Table selectable={false} multiSelectable={false}>
      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
        <TableRow>
          <TableHeaderColumn style={{ width: 50, paddingLeft: 10, paddingRight: 0 }} />
          <TableHeaderColumn style={{ width: 100 }}>{strings.Supervisor}</TableHeaderColumn>
          <TableHeaderColumn style={{ width: 100 }}>{strings.Employee_ID}</TableHeaderColumn>
          <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Total}</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody showRowHover={false} deselectOnClickaway={false} displayRowCheckbox={false}>
        {props.exceptionPunchSetRecordsBySupervisorDto.map((row, index) => {
          const supervisorId = row.Supervisor ? row.Supervisor.Id : strings.No_Supervisor
          const punchSets = row.PunchSetDocuments as any
          const shiftExceptions = row.ShiftExceptionDocuments as any
          return (
            <TableRow data-intercom-target={index === 0 && "ExceptionPunchSet-openExceptionPunchDetails"} key={index}>
              <TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Table
                  style={{ backgroundColor: "none" }}
                  selectable={false}
                  onCellClick={() => props.handleUpdateExpandedRowSupervisorId(row.Supervisor ? row.Supervisor.Id : strings.No_Supervisor)}
                >
                  <TableBody displayRowCheckbox={false}>
                    <TableRow style={{ cursor: "pointer", height: 48, borderBottom: "none" }}>
                      <TableRowColumn style={{ width: 50, paddingLeft: 10, paddingRight: 0 }}>
                        {row.Supervisor && row.Supervisor.ProfileImageS3Url &&
                          <ImageLoader url={row.Supervisor.ProfileImageS3Url} fixedHeight={75} avatar={true} src={"/users/profileimage/" + row.Supervisor.ProfileImageID} />
                        }
                      </TableRowColumn>
                      <TableRowColumn style={{ width: 100 }}>{row.Supervisor ? `${row.Supervisor.FirstName} ${row.Supervisor.LastName}` : strings.No_Supervisor}</TableRowColumn>
                      <TableRowColumn style={{ width: 100 }}>{row.Supervisor && row.Supervisor.ExternalId}</TableRowColumn>
                      <TableRowColumn style={{ textAlign: "left" }}>{row.TotalDocumentCount}</TableRowColumn>
                    </TableRow>
                    {supervisorId === props.expandedRowSupervisorId &&
                      <TableRow >
                        <TableRowColumn
                          colSpan={4}
                          style={{ paddingRight: 0, paddingLeft: 75, paddingBottom: 20 }}
                        >
                          <div onClick={(e) => { e.stopPropagation() }}>
                            {row.UnapprovedTimeoffs.length > 0 ?
                              <LeaveTrackingLiveView
                                unapprovedException
                                showStatuActionBar
                                showEmployeeExternalId
                                leaveRequests={row.UnapprovedTimeoffs}
                                updateStatusCb={props.reloadData}
                              /> :
                              row.SuspensePunches.length > 0 ?
                                <RecordTable
                                  hideExceptionCol
                                  showEmployeeExternalId
                                  pageMode={ERecordPageType.TopMenu}
                                  selectedFilter={ERecordSearchFilter.SuspensePunches}
                                  records={row.SuspensePunches}
                                  reload={init => init && props.reloadData()}
                                /> :
                                row.TimeFraudPunches.length > 0 ?
                                  <RecordTable
                                    hideExceptionCol
                                    showEmployeeExternalId
                                    pageMode={ERecordPageType.TopMenu}
                                    selectedFilter={ERecordSearchFilter.All}
                                    records={row.TimeFraudPunches}
                                    reload={init => init && props.reloadData()}
                                  /> :
                                  <ExceptionPunchSetsTable
                                    selectedFilterTypes={props.selectedFilterTypes}
                                    exceptionPunchSetRecordsDto={punchSets.concat(shiftExceptions)}
                                    pagination={false}
                                    onAddPunch={props.onAddPunch}
                                    onApprovePunchSet={props.onApprovePunchSet}
                                    handleShowExceptionDailog={props.handleShowExceptionDailog}
                                  />
                            }
                          </div>
                        </TableRowColumn>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableRowColumn>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}

export default ExceptionPunchSetsBySupervisorTable